// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  border: 0;
  margin: 0;
  padding: 0;
}

.primary-btn,
.secondary-btn {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border-radius: 4px;
}
.primary-btn .interal-button-content,
.secondary-btn .interal-button-content {
  gap: 4px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.primary-btn {
  background-color: var(--sebrae-blue-6);
}
.primary-btn span {
  color: var(--sebrae-white);
}
.primary-btn:hover {
  background-color: var(--sebrae-blue-3);
}

.secondary-btn {
  border: 1px solid var(--sebrae-blue-6);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.secondary-btn.selected {
  background-color: var(--sebrae-blue-6);
}
.secondary-btn.selected img {
  filter: brightness(0) invert(1);
}
.secondary-btn.selected span {
  color: var(--sebrae-white);
}
.secondary-btn.selected:hover {
  background-color: var(--sebrae-blue-3);
}
.secondary-btn .button-text {
  font-family: Figtree;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: var(--sebrae-blue-6);
}
.secondary-btn:hover {
  border: 1px solid var(--sebrae-blue-3);
  background-color: var(--sebrae-white-3);
}`, "",{"version":3,"sources":["webpack://./src/components/button/button.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;;EACE,QAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;;AAEA;EACE,sCAAA;AACF;AACE;EACE,0BAAA;AACJ;AAEE;EACE,sCAAA;AAAJ;;AAIA;EACE,sCAAA;EACA,6CAAA;AADF;AAGE;EACE,sCAAA;AADJ;AAGI;EACE,+BAAA;AADN;AAII;EACE,0BAAA;AAFN;AAKI;EACE,sCAAA;AAHN;AAOE;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AALJ;AAQE;EACE,sCAAA;EACA,uCAAA;AANJ","sourcesContent":["button {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.primary-btn,\n.secondary-btn {\n  width: 100%;\n  height: 40px;\n  padding: 8px 12px;\n  border-radius: 4px;\n\n  .interal-button-content {\n    gap: 4px;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.primary-btn {\n  background-color: var(--sebrae-blue-6);\n\n  span {\n    color: var(--sebrae-white);\n  }\n\n  &:hover {\n    background-color: var(--sebrae-blue-3);\n  }\n}\n\n.secondary-btn {\n  border: 1px solid var(--sebrae-blue-6);\n  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n\n  &.selected {\n    background-color: var(--sebrae-blue-6);\n\n    img {\n      filter: brightness(0) invert(1);\n    }\n\n    span {\n      color: var(--sebrae-white);\n    }\n\n    &:hover {\n      background-color: var(--sebrae-blue-3);\n    }\n  }\n\n  .button-text {\n    font-family: Figtree;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    color: var(--sebrae-blue-6);\n  }\n\n  &:hover {\n    border: 1px solid var(--sebrae-blue-3);\n    background-color: var(--sebrae-white-3);\n  }\n}\n\n// .btn-solution {\n//     background-image: linear-gradient(35deg, #CD5BE8 0%, #FFABAB 100%);\n//     width: 100%;\n//     padding: 8px 16px;\n//     display: flex;\n\n//     font: {\n//       family: Campuni;\n//       weight: bold;\n//       size: 12px;\n//     }\n\n//     ;\n//     color: var(--sebrae-light-gray);\n//     box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);\n//     justify-content: center;\n//     align-items: center;\n//     gap: 8px;\n\n//     .wrapper-icon {\n//       position: relative;\n//       width: 20px;\n//       height: 20px;\n\n//       img {\n//         width: 100%;\n//         height: 100%;\n//       }\n\n//       .notification {\n//         position: absolute;\n//         top: 12%;\n//         left: 90%;\n//         transform: translate(-50%, -50%);\n//         background-color: #DB340B;\n//         width: 14px;\n//         height: 14px;\n//         border-radius: 50px;\n\n//         font: {\n//           family: Lato;\n//           size: 8px;\n//           weight: bold;\n//         }\n\n//         ;\n//         color: var(--sebrae-white);\n//         display: flex;\n//         justify-content: center;\n//         align-items: center;\n//       }\n//     }\n\n\n//     @media(min-width: 768px) {\n//       margin-block: 24px;\n//       border-radius: 4px;\n//     }\n//   }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
